export const STORAGE_KEY = "HOME_PAGE_ORDER"; 